import { MetaView, useTable, withTable } from '@oscar/table';
import { Space } from '@oscar/theme';
import { FilterTable, PageHeader } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import { useAuth } from 'features/auth';
import { columns, transformRequest, transformResponse } from '../utils';
import './style.scss';

export type HomeTabProps = {
  currentRole?: string[];
};

const Table = withTable<HomeTabProps>({
  name: 'all-requests',
  keyField: 'id',
  mode: 'REMOTE',
  request: {
    name: 'all-requests',
    url: APIS.ALL_REQUESTS,
    method: 'POST',
    transformRequest: transformRequest,
    transformResponse: transformResponse,
    nextData: props => {
      return props;
    },
  },
  columns,
});

const Requests = () => {
  const [table] = useTable();
  const [auth] = useAuth();
  if (auth.getUserRoles()?.length === 0) {
    return null;
  }

  return (
    <div className="request-list">
      <PageHeader title="All Requests" />

      <div className="main-request-list">
        <MetaView table={table}>
          {(childProps: any) => (
            <FilterTable
              actionTable={childProps?.table}
              metadata={childProps?.metadata}
            />
          )}
        </MetaView>
        <Space size={[16, 16]} direction="vertical" className="space-table">
          <Table
            key="all-request"
            rowKey="id"
            table={table}
            currentRole={auth.getUserRoles()}
          />
        </Space>
      </div>
    </div>
  );
};

export default Requests;
